if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
      const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
          if (item.target.classList?.contains('product-recommendations') || item.target.classList?.contains('top-[calc(100%+12px)]')) {
            window.dispatchEvent(new Event('scroll'))
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }, 300);
  }

function formatMoney(value) {
  return '$' + value.toFixed(2);
}

function updatePriceByQty() {
  const container = document.querySelector('#price-template--26956672598386__main');
  const qtyInput = document.querySelector('#Quantity-atc-template--26956672598386__main');

  if (!container || !qtyInput) return;

  const spans = container.querySelectorAll('span');
  if (spans.length < 2) return;

  const originalEl = spans[0]; // giá gạch
  const discountEl = spans[1]; // giá đỏ

  // Lấy giá ban đầu (chỉ parse 1 lần rồi lưu lại)
  if (!originalEl.dataset.price) {
    originalEl.dataset.price = parseFloat(originalEl.innerText.replace(/[^0-9.]/g, ''));
  }
  if (!discountEl.dataset.price) {
    discountEl.dataset.price = parseFloat(discountEl.innerText.replace(/[^0-9.]/g, ''));
  }

  const baseOriginal = parseFloat(originalEl.dataset.price);
  const baseDiscount = parseFloat(discountEl.dataset.price);

  const qty = parseInt(qtyInput.value) || 1;

  originalEl.innerText = formatMoney(baseOriginal * qty);
  discountEl.innerText = formatMoney(baseDiscount * qty);
}

// listen change
document.addEventListener('input', (e) => {
  if (e.target.matches('#Quantity-atc-template--26956672598386__main')) {
    updatePriceByQty();
  }
});

document.addEventListener('click', (e) => {
  if (
    e.target.closest('[bss-b2b-btn-down-quantity]') ||
    e.target.closest('[bss-b2b-btn-up-quantity]')
  ) {
    setTimeout(updatePriceByQty, 100);
  }
}, true);

let counter = 0;
let selector = '#price-template--26956672598386__main span[style*="line-through"]'
const interval = setInterval(() => {
    let element = document.querySelector(selector);
    if (element) {
        console.log("Phần tử đã xuất hiện");
        clearInterval(interval);
        updatePriceByQty()
    } else {
        counter += 100;
        if (counter >= 10000) {
            clearInterval(interval);
        }
    }
}, 100); 
